import { RootState } from '../store';

export const selectNotifications = (state: RootState) => state.notification.notifications;

export const selectNotificationsRequestStatus = (state: RootState) => state.notification.notificationsRequestStatus;
